import React from "react";

export default function SectionHead({ title, subtitle }) {
  return (
    <div className="mb-5">
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
    </div>
  );
}
